import { render, staticRenderFns } from "./numberItem.vue?vue&type=template&id=7d48cb00"
import script from "./numberItem.vue?vue&type=script&lang=js"
export * from "./numberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports